import { Component, OnInit } from '@angular/core';
import { Article } from 'src/app/models/article';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-tracarticles',
  templateUrl: './tracarticles.component.html',
  styleUrls: ['./tracarticles.component.css']
})
export class TracarticlesComponent implements OnInit {
  
  private numArticleCourant: string = "";
  private articleCourant: object = {};

  constructor(private appService: AppService) { }

  ngOnInit() {
  }

  rechercher() {
    this.articleCourant = this.appService.articles.find(articleCourant => articleCourant.num === this.numArticleCourant);
  }

}
